interface TitleFieldProps {
  value: string;
  onChange: (v: string) => void;
  error?: string;
}

export default function TitleField({ value, onChange, error }: TitleFieldProps) {
  return (
    <div>
      <label className="block text-sm font-semibold text-zinc-300 mb-2 tracking-wide uppercase" style={{ fontFamily: 'Cinzel, serif' }}>
        Story Title <span className="text-red-500">*</span>
      </label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Enter your story title..."
        maxLength={120}
        className={`w-full bg-zinc-900 border ${error ? 'border-red-500' : 'border-zinc-700'} rounded-lg px-5 py-4 text-white text-lg placeholder-zinc-600 focus:outline-none focus:border-red-600 transition-colors`}
        style={{ fontFamily: 'Crimson Text, serif' }}
      />
      <div className="flex items-center justify-between mt-1">
        {error ? (
          <p className="text-red-400 text-xs flex items-center gap-1">
            <i className="ri-error-warning-line"></i> {error}
          </p>
        ) : (
          <span />
        )}
        <span className="text-zinc-600 text-xs">{value.length}/120</span>
      </div>
    </div>
  );
}
